import SectionHeader from '@Web/Src/Components/SectionHeader';
import { TUTORIALS } from '@Web/Pages/Web/Home/constants.jsx';
import TutorialItem from './Components/TutorialItem';
import Button from '@Web/Src/Components/Button';
import { useState } from 'react';

import styles from './style.module.scss';

function Tutorials() {
    const [selected, setSelected] = useState(TUTORIALS[0]);
    const [isPlaying, setIsPlaying] = useState(false);

    const handleGoToYouTubeChannel = () => {
        window.open(
            'https://www.youtube.com/@ReferralFactory',
            '_self',
            'noopener, noreferrer'
        );
    };

    return (
        <div className='bg-dark small:px-6 mt-44 w-full rounded-3xl px-12 pb-24 pt-16'>
            <SectionHeader
                className='mx-auto'
                type='light'
                icon='youtube'
                title={__('Learn how to use our referral software')}
                desc={__(
                    'Learn how to build and launch your own referral program or affiliate program. Our YouTube channel offers expert tips and tutorials. Watch our bite-sized videos and see how easy it is to use our customer referral program software.'
                )}
            />
            <div className='large:flex-col mx-auto mt-14 flex max-w-5xl gap-8'>
                <div
                    style={{
                        backgroundImage: `url(https://i.ytimg.com/vi_webp/${selected.id}/sddefault.webp)`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        backgroundRepeat: 'no-repeat',
                    }}
                    className='large:min-h-72 relative w-full flex-1 overflow-hidden rounded-3xl'
                >
                    {!isPlaying && (
                        <div
                            className={`large:min-h-72 ${styles.youtube_button}`}
                            onClick={() => setIsPlaying(true)}
                        ></div>
                    )}
                    {isPlaying && (
                        <iframe
                            className={'large:min-h-72'}
                            width='100%'
                            height='100%'
                            src={selected.url}
                            title={selected.title}
                            allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
                            referrerPolicy='strict-origin-when-cross-origin'
                            allowFullScreen
                        />
                    )}
                </div>
                <div className='min-w-[240px] flex-1'>
                    <p className='font-bold'>{__('OUR TUTORIALS')}</p>
                    {TUTORIALS.map((item, index) => {
                        return (
                            <TutorialItem
                                selected={selected}
                                key={index}
                                item={item}
                                setSelected={setSelected}
                            />
                        );
                    })}
                    <Button
                        name='Go to YouTube Channel&nbsp;&nbsp;&nbsp;&nbsp;&#8599;'
                        className='mt-5 h-12'
                        onClick={handleGoToYouTubeChannel}
                    />
                </div>
            </div>
        </div>
    );
}

export default Tutorials;
